import { Skeleton, Typography } from '@mui/material';
import React from 'react';
import { Column, Row } from '../../../../../styles';

export const ProjectDetailsCoWorkLoadingComments = () => (
    <Row width='100%' height={40} stretch>
        <Row width='40%' height='100%' gap={2}>
            <Skeleton variant='circular' width={40} height={40} />
            <Column width='70%' height='100%' justifyContent={'space-between'}>
                <Typography variant='subtitle2' width='100%' height='45%' mb={0.5}>
                    <Skeleton variant='rounded' width='100%' height='100%' />
                </Typography>
                <Typography variant='subtitle2' width='100%' height='45%'>
                    <Skeleton variant='rounded' width='100%' height='100%' />
                </Typography>
            </Column>
        </Row>
        <Row width='50%' height='100%' gap={5}>
            <Skeleton variant='rounded' width='50%' height='70%' />
            <Skeleton variant='rounded' width='50%' height='70%' />
        </Row>
    </Row>
);
